import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";
const qs = require("qs");

export async function fetchBanner(params) {
  return await request({
    url: ENDPOINT.BANNER,
    method: "get",
    params,
  });
}

export async function fetchBannerById(id) {
  return await request({
    url: `${ENDPOINT.BANNER}/${id}/edit`,
    method: "get",
  });
}

export async function createBanner(data) {
  return await request({
    url: ENDPOINT.BANNER,
    method: "post",
    data,
  });
}

export async function updateBanner(id, data) {
  return await request({
    url: `${ENDPOINT.BANNER}/${id}`,
    method: "post",
    data,
  });
}

export async function deleteBanner(id, data) {
  return await request({
    url: `${ENDPOINT.BANNER}/${id}`,
    method: "post",
    data: qs.stringify(data),
  });
}
